/* Session-scoped candidate queue so Previous / Next on the profile walks
   the same list the recruiter was looking at (Candidates table, Pipeline
   board, CV Bank, search), not an arbitrary server page. */

export const BROWSE_KEY = 'tf-candidate-browse'

export function uniqueBrowseEntries(rows = []) {
  const entries = []
  const seen = new Set()
  for (const row of rows) {
    if (!row) continue
    const userId = String(row.userId ?? row.user_id ?? '').trim()
    if (!userId || seen.has(userId)) continue
    seen.add(userId)
    entries.push({
      userId,
      name: String(row.name || row.email || 'Candidate'),
      stage: row.stage || null,
      jobTitle: row.jobTitle || row.job_title || null,
    })
  }
  return entries
}

export function neighborsOf(entries, userId) {
  const id = String(userId ?? '')
  const index = entries.findIndex((entry) => entry.userId === id)
  return {
    index,
    total: entries.length,
    prev: index > 0 ? entries[index - 1] : null,
    next: index >= 0 && index < entries.length - 1 ? entries[index + 1] : null,
    current: index >= 0 ? entries[index] : null,
    entries,
  }
}

/** `?inbox=` / `?manual=` pin one application; `/candidate/:id` alone shows the user's first. */
function applicationParams(row) {
  if (!row) return {}
  const inbox = row.inboxId ?? row.inbox_id ?? null
  if (inbox != null && inbox !== '') return { inbox: String(inbox) }
  const manual = row.manualUploadId ?? row.manual_upload_candidate_id ?? null
  if (manual != null && manual !== '') return { manual: String(manual) }
  return {}
}

export function candidatePath(userId, tab, application) {
  const path = `/candidate/${encodeURIComponent(userId)}`
  const params = new URLSearchParams(applicationParams(application))
  if (tab) params.set('tab', tab)
  const query = params.toString()
  return query ? `${path}?${query}` : path
}

export function rememberCandidateBrowse(rows) {
  const entries = uniqueBrowseEntries(rows)
  try {
    sessionStorage.setItem(BROWSE_KEY, JSON.stringify({ entries }))
  } catch { /* private mode / quota — browsing still works for this click */ }
  return entries
}

export function readCandidateBrowse() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(BROWSE_KEY) || 'null')
    return uniqueBrowseEntries(parsed?.entries || [])
  } catch {
    return []
  }
}

/** `application` is the clicked list row, so the profile opens that application. */
export function openCandidateProfile(navigate, userId, rows, { replace = false, tab, application } = {}) {
  if (rows) rememberCandidateBrowse(rows)
  if (!userId) return
  navigate(candidatePath(userId, tab, application), { replace })
}
